import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@nutrien/cxp-components';
import React from 'react';
import { withRouter } from 'react-router-dom';

const useStyles = makeStyles({
  linkContainer: {
    marginTop: '0px',
  },
  title: {
    textAlign: 'center',
    fontWeight: 700,
    width: '100%',
  },
  subtitle: {
    textAlign: 'center',
    fontWeight: 400,
    margin: '20px 0px 34px 0px',
    width: '100%',
  },
  button: {
    width: '190px',
    margin: '0 auto',
    marginTop: '50px',
  },
});

const ConfirmationView = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={0} className={classes.linkContainer} justifyContent="center">
        <Typography variant="h5" className={classes.title} fontWeight="bold">
          Success!
        </Typography>
        <Typography variant="body1" color="textSecondary" className={classes.subtitle}>
          Your password has been successfully updated.
        </Typography>
        <Button
          size="medium"
          variant="contained"
          color="primary"
          className={classes.button}
          fullWidth={false}
          noMinHeight
          onClick={() => window.location.replace('/login')}
        >
          Login
        </Button>
      </Grid>
    </>
  );
};

export default withRouter(ConfirmationView);
